import { defineStore } from "pinia";
import { ref } from "vue";

import { Pagination } from "@/interfaces/paginatedResponse";
import { Cef } from "@/modules/trips/interfaces/cef";

export const useCefsStore = defineStore("cefs", () => {
  const pagination = ref<Pagination>();
  const cefs = ref<Cef[]>([]);

  const page = ref<string | number>("1");

  return {
    pagination,
    cefs,

    page,

    setCefs(newCefs: Cef[]) {
      cefs.value = [];
      cefs.value = newCefs;
    },

    setPagination(newMeta: Pagination) {
      pagination.value = newMeta;
    },

    setPage(newPage: string | number) {
      page.value = newPage;
    },
  };
});
